var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { MiniStore } from '../../mini-ngrx/store.class';
import { initialDatepickerState } from './bs-datepicker.state';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MiniState } from '../../mini-ngrx/state.class';
import { bsDatepickerReducer } from './bs-datepicker.reducer';
var BsDatepickerStore = (function (_super) {
    __extends(BsDatepickerStore, _super);
    function BsDatepickerStore() {
        var _this = this;
        var _dispatcher = new BehaviorSubject({ type: '[datepicker] dispatcher init' });
        var state = new MiniState(initialDatepickerState, _dispatcher, bsDatepickerReducer);
        _this = _super.call(this, _dispatcher, bsDatepickerReducer, state) || this;
        return _this;
    }
    BsDatepickerStore.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDatepickerStore.ctorParameters = function () { return []; };
    return BsDatepickerStore;
}(MiniStore));
export { BsDatepickerStore };
//# sourceMappingURL=bs-datepicker.store.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/reducer/bs-datepicker.store.js
// module id = 177
// module chunks = 42